export default __webpack_public_path__ + "static/media/logo@3x.9f736f39.png";